import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import styles from './styles.m.scss';

const propTypes = {
  isError: PropTypes.bool,
  isOpen: PropTypes.bool,
  message: PropTypes.string,
};

const Toast = ({ isError, isOpen, message }) => {
  const toastClasses = classnames(styles.toast, { [styles.error]: isError });

  return (
    <div
      className={toastClasses}
      style={{
        transform: isOpen ? 'translate3d(-50%, 0, 0)' : `translate3d(-50%, 80px, 0)`,
        visibility: isOpen ? 'visible' : 'hidden',
      }}
    >
      <span>{message}</span>
    </div>
  );
};

Toast.propTypes = propTypes;

export default Toast;
